// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z8Xz","toggleWrap":"styles_toggleWrap__1DrRJ","content":"styles_content__3rPDM","selectAreaCode":"styles_selectAreaCode__SgJfx"};